import {
  DASHBOARD_REQUEST,
    DASHBOARD_SUCCESS,
    DASHBOARD_FAIL,
    DASHBOARD_CLEAR_ERRORS
  
} from "../Constants/dashboard_const";

export const dashboardReducer = (
  state = {
    dashboard: [],
  },
  action
) => {
  switch (action.type) {
    case DASHBOARD_REQUEST:
      return {
        loading: true,
        dashboard: [],
      };
    case DASHBOARD_SUCCESS:
      return {
        loading: false,
        dashboard: action.payload.data,
      };
    case DASHBOARD_FAIL:
      return {
        loading: false,
        dashboard: null,
        dashboard_error: action.payload,
      };

    case DASHBOARD_CLEAR_ERRORS:
      return {
        ...state,
        dashboard_error: null,
      };
    default:
      return state;
  }
};
